<script>
import EmojiGlyph from 'shared/components/emoji/EmojiGlyph.vue';
import { rememberRecentReaction } from 'shared/helpers/recentReactions';

export default {
  name: 'MessageReactionBar',
  components: { EmojiGlyph },
  props: {
    large: {
      type: Boolean,
      default: true,
    },
    // Aceleres: no modal de reacoes a barra e so pra trocar a propria
    // reacao, entao o "+" (que abre o seletor completo ancorado no balao)
    // nao faz sentido ali. Default false mantem o comportamento de sempre.
    hideMore: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['react', 'more', 'close'],
  data() {
    return {
      quickEmojis: ['👍', '❤️', '😂', '😮', '😢', '🙏'],
      labels: {
        toolbar: 'Reações rápidas',
        reactWith: 'Reagir com',
        more: 'Mais reações',
      },
    };
  },
  methods: {
    reactWith(emoji) {
      rememberRecentReaction(emoji);
      this.$emit('react', emoji);
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.$emit('close');
        return;
      }

      const navigationKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!navigationKeys.includes(event.key)) return;

      const buttons = [...event.currentTarget.querySelectorAll('button')];
      const currentIndex = buttons.indexOf(event.target.closest('button'));
      if (currentIndex < 0) return;

      event.preventDefault();
      let nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      } else if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % buttons.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = buttons.length - 1;
      }
      buttons[nextIndex]?.focus();
    },
  },
};
</script>

<template>
  <div
    class="aceleres-reaction-bar flex items-center gap-0.5 px-1 py-1"
    role="toolbar"
    :aria-label="labels.toolbar"
    @keydown="handleKeydown"
  >
    <button
      v-for="emoji in quickEmojis"
      :key="emoji"
      type="button"
      class="aceleres-emoji-btn text-[1.75rem] leading-none h-6 w-6 flex items-center justify-center rounded-full hover:bg-n-alpha-1 hover:scale-125 transition-all duration-150"
      :class="{ '!h-10 !w-10': large }"
      :aria-label="`${labels.reactWith} ${emoji}`"
      @click.stop="reactWith(emoji)"
    >
      <EmojiGlyph
        :emoji="emoji"
        :class="{ '!h-10 !w-10 !text-[2.5rem]': large }"
      />
    </button>
    <button
      v-if="!hideMore"
      type="button"
      class="aceleres-emoji-btn aceleres-emoji-btn--more h-6 w-6 flex items-center justify-center rounded-full text-n-slate-11 transition-all duration-150"
      :class="{ '!h-10 !w-10': large }"
      :aria-label="labels.more"
      @click.stop="$emit('more', $event)"
    >
      <span class="i-lucide-plus w-4 h-4" />
    </button>
  </div>
</template>
